import momentCN from 'moment/locale/zh-cn'

const components = {
  momentName: 'zh-cn',
  momentLocale: momentCN
}

const locale = {
  'message': '-',
  'layouts.EmailMarketing': '邮件营销',
  'layouts.application': '应用',
  'layouts.current': '正在使用',
  'layouts.switch': '切换{0}',
  'layouts.change': '菜单置于{0}',
  'layouts.new.version': '新版',
  'layouts.new': '新增',
  'layouts.edit': '编辑',
  'layouts.show': '显示{0}',
  'layouts.hide': '隐藏{0}',
  'layouts.paidPage': '付费页面',
  'layouts.expired': '过期',
  'layouts.upgrade': '升级',
  'layouts.buy': '购买',
  'layouts.onlineservice': '在线客服',
  'layouts.MoneyAssistant': '资金助手',
  'layouts.accountSettings': '账号设置',
  'layouts.usercenter': '用户中心',
  'layouts.authority': '权限管理',
  'layouts.store.authorization': '店铺授权',
  'layouts.helpcenter': '帮助中心',
  'layouts.menusyl': '菜单样式',
  'layouts.menusyl.top': '顶部菜单布局',
  'layouts.menusyl.left': '侧边菜单布局',
  'layouts.menutransformation': '全部菜单',
  'layouts.logout': '退出系统',
  'layouts.allapplication': '全部应用',
  'layouts.history': '最近打开',
  'layouts.customscene': '{0}自定义场景',
  'layouts.demo.tips': 'DEMO环境不支持该操作，您可以使用自有账号操作该功能',
  'layouts.customscene.currentNoDel': '正在使用的场景不允许删除，请先切换到其他场景再进行删除',
  'layouts.allmenu': '全部菜单',
  'layouts.menusearch': '请输入关键词，搜索菜单',
  'layouts.commonmenu': '常用菜单',
  'layouts.search.placeholder': '请输入关键词，搜索菜单',
  'layouts.text.undefined': '暂无数据',
  'layouts.operation.guide': '操作指南',
  'layouts.bookmarks': '常用功能收藏夹',
  'layouts.bookmarks.success': '添加收藏成功',
  'layouts.bookmarks.cancel': '取消收藏成功',
  'layouts.openAll': '一键全开',
  'layouts.manageFavorites': '管理收藏夹',
  'layouts.ViewAll': '查看全部功能',
  'layout.searchKeyword': '搜索关键词',
  'layout.error-401': '抱歉，您没有访问权限，请联系管理人员',

  'version-modal.title': '切换须知',
  'version-modal.tips': '此次切换将不可退回至现有版本，你还可以通过查看新版介绍进行全面的了解',
  'version-modal.info': '切换到轻易ERP之后，将会有以下变化:',
  'version-modal.subInfo-1': '系统Ul的改变',
  'version-modal.subInfo-2': '菜单顺序的改变',
  'version-modal.subInfo-3': '功能可能会相应删减和增加，但不会影响基本的业务流程',
  'version-modal.footer': '我已经了解上述情况，同意切换。',
  'version-modal.viewDemo': '查看Demo',

  'store-tip.title': '出海利器 大卖必备',
  'store-tip.subtitle': '2分钟快速授权',
  'store-tip.guide': '科技赋能 开启精益运营之门',
  'store-tip.info-1': '多店铺管理<br>安全防关联',
  'store-tip.info-2': '实时数据同步<br>安全可靠',
  'store-tip.info-3': '运营风险<br>及时提醒',
  'store-tip.remind': '本次登录不再提醒',
  'store-tip.btn': '店铺授权',

  'form-modal.cancel': '取消',
  'form-modal.submit': '确认',
  'form-modal.delete': '删除',
  'form-modal.selected': '已选中',
  'form-modal.action': '个操作',
  'form-modal.third-party-abnormal': '第三方系统异常！',
  'form-modal.custom.title': '自定义场景面板',
  'form-modal.customMenuName': '场景名称',
  'form-modal.system.title': '自定义应用菜单',
  'form-modal.menuname.placeholder': '请输入自定义场景名称',
  'form-modal.remark.placeholder': '备注',
  'form-modal.rule.maxstring': '最多支持{0}个字符串',
  'form-modal.rule.maxobject': '最多选择{0}项',
  'form-modal.rule.select': '请选择{0}',
  'notification-modal.title.prompt': '温馨提示',
  'notification-modal.content.delete.customscene': '是否确定删除该场景，该操作不可恢复',
  'notification-modal.content.maxcustomscene': '最多可创建30个场景，您可以删除废弃的场景或编辑现有场景',
  'logout.title': '退出确认',
  'logout.content': '确定退出登录吗？',
  'logout.okText': '确认',
  'logout.cancelText': '取消',
  'tabs.close.current': '关闭当前标签',
  'tabs.close.right': '关闭右侧',
  'tabs.close.left': '关闭左侧',
  'tabs.close.all': '关闭全部'
}

export default {
  ...components,
  ...locale
}
